import { useMutation } from "@apollo/client";
import {
  DUPLICATE_GENERATION_TEMPLATE,
  GET_GENERATION_TEMPLATES,
} from "../gql";

interface UseDuplicateGenerationTemplateResult {
  duplicateTemplate: (
    agentId: string,
    newName: string,
    userId: string,
  ) => Promise<string>;
  loading: boolean;
  error: Error | null;
}

export function useDuplicateGenerationTemplate(
  organizationId: string,
): UseDuplicateGenerationTemplateResult {
  const [mutate, { loading, error }] = useMutation<{
    duplicateGenerationTemplate: { uuid: string };
  }>(DUPLICATE_GENERATION_TEMPLATE, {
    refetchQueries: [
      {
        query: GET_GENERATION_TEMPLATES,
        variables: { organizationId },
      },
    ],
  });

  const duplicateTemplate = async (
    agentId: string,
    newName: string,
    userId: string,
  ): Promise<string> => {
    const result = await mutate({
      variables: { agentId, newName, userId },
    });

    if (!result.data?.duplicateGenerationTemplate?.uuid) {
      throw new Error("Failed to duplicate template");
    }

    return result.data.duplicateGenerationTemplate.uuid;
  };

  return {
    duplicateTemplate,
    loading,
    error: error || null,
  };
}
